import { useMediaQuery } from "@react-hookz/web";
import { Marker as MapboxMarker } from "react-map-gl";

interface MarkerProps {
  type: "default" | "user";
  lat: number;
  lng: number;
}

export function Marker(props: MarkerProps) {
  const isSmallMobileDevice = useMediaQuery("(max-device-height: 650px)");

  const size = props.type === "default" ? 40 : 20;
  let offset = isSmallMobileDevice ? -50 : 0;
  offset = props.type === "default" ? offset : offset + 25;

  return (
    <MapboxMarker latitude={props.lat} longitude={props.lng} offset={[offset / 2, offset]}>
      <div
        className={"flex cursor-pointer rounded-full"}
        style={{ transform: `translate(${-size / 2}px,${-size}px)` }}
      >
        {props.type === "default" ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="9.5" fill="#1DA1F2" stroke="white" />
          </svg>
        ) : (
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 12.3C28 22.1013 16.5 33 16.5 33C16.5 33 5 22.1013 5 12.3C5 5.94873 10.1487 0.800007 16.5 0.800006C22.8513 0.800006 28 5.94873 28 12.3Z"
              fill="#F15B3C"
            />
            <circle cx="16.5" cy="12.3" r="4.6" fill="white" />
          </svg>
        )}
      </div>
    </MapboxMarker>
  );
}
